import request from "../util/client";
import { ListParams, ListResponse } from "./types";

export interface InventoryData {
    id: number;
    ref_id: string;
    info: {
        order_id: string;
        shipment_id: string;
        customer_name: string;
        customer_id: string;
        image?: string | Array<string>;
    };
    created_at: number;
}

export interface InventoryItemData {
    inventory_id: number;
    sku: string;
}

export interface CodeFormatRow {
    id?: number;
    name?: string;
    separator?: string;
    min: number;
    max?: number;
    fields: Array<string>;
    priority?: number;
    config?: { fields: Array<string>, sku: Array<string> }
};

export function getInventory(params: ListParams<Partial<InventoryData> & { q?: string }> | URLSearchParams) {
    return request<ListResponse<InventoryData>>('inventories', 'GET', params);
}

export function getInventoryItems(params: { id: number }) {
    return request<Array<InventoryItemData>>('inventory/item', 'GET', params);
}

export function deleteInventory(id: number) {
    return request<string>('inventory', 'DELETE', { id });
}

export function getMappedCode(id: Array<string | number> | string | number) {
    return request<Record<string, string>>('code_map', 'GET', { id });
}

export function getParsingRules(id?: number) {
    return request<Array<CodeFormatRow>>('code_format', 'GET', id ? { id } : undefined)
}

export function saveParsingRules(rules: Array<Partial<CodeFormatRow>>) {
    return request<string>('code_format', 'PUT', rules);
}
